import appealReferralDetailsPropType from './appealReferralDetailsPropType';

export { appealReferralDetailsPropType };
